
export type FilterPreset = Record<string, string[]>;

export type ReportPresetQuery = {
    filters?: string;          // JSON -> encodeURIComponent
    period?: string;           // e.g. 'LAST_7_DAYS'
    start?: string;            // 'YYYY-MM-DD' (для CUSTOM_RANGE)
    end?: string;              // 'YYYY-MM-DD'
    tz?: string;               // timezoneId
    autogen?: '1' | '0';       // авто-генерация после применения
};

// export const ALLOWED_DIMENSIONS = new Set([
//     'SspId', 'AdvertiserId', 'CampaignId', 'AdGroupId',
//     'CreativeId', 'CountryIso3', 'DeviceType', 'Browser',
// ]);

export function encodeFilters(filters: FilterPreset): string {
    const clean: FilterPreset = {};
    Object.entries(filters).forEach(([k, arr]) => {
        // if (!ALLOWED_DIMENSIONS.has(k)) { return; }
        const vals = Array.from(new Set((arr ?? []).map(v => String(v).trim()).filter(Boolean)));
        if (vals.length) { clean[k] = vals; }
    });
    return encodeURIComponent(JSON.stringify(clean));
}

export function decodeFilters(encoded: string | null): FilterPreset | null {
    if (!encoded) { return null; }
    try {
        const obj = JSON.parse(decodeURIComponent(encoded));
        if (!obj || typeof obj !== 'object') { return null; }
        const out: FilterPreset = {};
        Object.entries(obj as Record<string, unknown>).forEach(([k, v]) => {
            // if (!ALLOWED_DIMENSIONS.has(k)) { return; }
            if (Array.isArray(v)) {
                const vals = v.map(x => String(x)).filter(Boolean);
                if (vals.length) { out[k] = vals; }
            }
        });
        return out;
    } catch {
        return null;
    }
}
